import React, { useEffect, useState } from "react";
import {
  CAMPAIGNPRODUCTS, CAMPAIGNPRODUCTSFilterproduct
} from "../../store/Compaign/Action";
import { useTranslation } from 'react-i18next';
import { useStateValue } from "../../store/state";
import { useParams } from "react-router-dom";
import "../../components/ProductCard/ProductCard.scss";
import "./CampaignProduct.scss";
import request from "../../request";
import InfiniteScroll from "react-infinite-scroll-component";
import NewCardSkeleton from "../../components/Skeleton/NewCardSkeleton/NewCardSkeleton";
import ProductCard from "../../components/ProductCard/ProductCard";
import CampaignSidebar from "./CampaignSidebar";

function CampaignProduct() {
  const { CDN_PRODUCT_CAMPAIGN } = request;
  const [
    { campaignProducts, campaignProductsCount, bannerImage, filterTitle, filterDetails, thaiTitle, filterdetailsthai, responsiveImage },
    dispatch,
  ] = useStateValue();
  const { t } = useTranslation()
  const { Id, categoryId } = useParams();
  const [loader, setLoader] = useState(true);
  const [filteredProducts, setFilteredProducts] = useState([]); // Keep track of all loaded products
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [refreshAPI, setRefreshAPI] = useState(false);
  const [currentSelection, setCurrentSelection] = useState({
    ID: "",
    subID: "",
  });
  const [mobileCategory, setMobileCategory] = useState("");
  const [currentpage, setCurrentPage] = useState(1); // Initialize STOREID state

  const [containerClass, setContainerClass] = useState("container"); // Default class name

  // Function to handle window resize
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    let TOKEN = localStorage.getItem("token");
    let COMPANYID = localStorage.getItem("companyid");
    let USERID = localStorage.getItem("userid");
    let STOREID = localStorage.getItem("storeid");
    if (Id) {
      CAMPAIGNPRODUCTSFilterproduct(
        dispatch,

        TOKEN,
        Id,
        STOREID,
        categoryId
      );
    }
  }, [Id]);
  // Update class name based on window width
  useEffect(() => {
    if (windowWidth <= 768) {
      setContainerClass("containerdata"); // Class for mobile
    } else {
      setContainerClass("container"); // Class for desktop
    }
  }, [windowWidth]);

  useEffect(() => {
    setCurrentPage(1); // Reset to page 1
    setFilteredProducts([]); // Clear previous filtered products
    dispatch({ type: 'SET_CATEGORY' }); // Reset campaign products

    let TOKEN = localStorage.getItem("token");
    let COMPANYID = localStorage.getItem("companyid");
    let USERID = localStorage.getItem("userid");
    let STOREID = localStorage.getItem("storeid");
    let COUNTRYDATA = "CountryX";
    let BRANDDATA = "BrandY";
    // Fetch new campaign products based on the new Id and categoryId
    CAMPAIGNPRODUCTS(
      dispatch,
      TOKEN,
      COMPANYID,
      STOREID,
      USERID,
      Id,
      STOREID,
      categoryId,
      currentSelection.subID, // Changed from currentSelection.ID to currentSelection.subID
      currentpage,
      BRANDDATA,
      COUNTRYDATA,
      "BrandY",
      "coffeeshop",
      "household",
      "sme"
    );
  }, [Id, categoryId]);

  useEffect(() => {

    if (currentpage > 1 && currentpage <= Math.ceil(campaignProductsCount / 20)) {
      let TOKEN = localStorage.getItem("token");
      let COMPANYID = localStorage.getItem("companyid");
      let USERID = localStorage.getItem("userid");
      let STOREID = localStorage.getItem("storeid");
      let COUNTRYDATA = "CountryX";
      let BRANDDATA = "BrandY";

      CAMPAIGNPRODUCTS(
        dispatch,
        TOKEN,
        COMPANYID,
        STOREID,
        USERID,
        Id,
        STOREID,
        categoryId,
        currentSelection.ID,
        currentpage,
        BRANDDATA,
        COUNTRYDATA,
        "BrandY",
        "coffeeshop",
        "household",
        "sme"
      );
    }
  }, [currentpage]);

  const loadNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  useEffect(() => {
    let filtered = campaignProducts;
    if (searchQuery) {
      filtered = filtered.filter(
        (product) =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.sku.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredProducts(filtered);
  }, [selectedCategory, campaignProducts, searchQuery, dispatch]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    if (currentSelection.ID && currentSelection.subID) {
      setCurrentPage(1);
      setFilteredProducts([]);
      dispatch({ type: 'SET_CATEGORY' });

      let TOKEN = localStorage.getItem("token");
      let COMPANYID = localStorage.getItem("companyid");
      let USERID = localStorage.getItem("userid");
      let STOREID = localStorage.getItem("storeid");
      let COUNTRYDATA = "CountryX";
      let BRANDDATA = "BrandY";

      // Fetch new campaign products based on the new Id and categoryId
      // if (currentSelection.ID && currentSelection.subID) {
      CAMPAIGNPRODUCTS(
        dispatch,
        TOKEN,
        COMPANYID,
        STOREID,
        USERID,
        Id,
        STOREID,
        categoryId,
        currentSelection.subID,
        currentpage,
        BRANDDATA,
        COUNTRYDATA,
        "BrandY",
        "coffeeshop",
        "household",
        "sme"
      );
    }

  }, [currentSelection]);

  useEffect(() => {
    if (campaignProducts?.products) {
      campaignProducts?.products?.filter(data => (
        setFilteredProducts(prevState => [
          ...prevState,
          data
        ])
      ))
    }
  }, [campaignProducts]);

  return (
    <div className={containerClass}>
      <div className="compaign-product-card">
        <div className="banner">
          {bannerImage && (
            <>
              {windowWidth <= 768 ? (
                <img src={`${CDN_PRODUCT_CAMPAIGN}${responsiveImage}`} alt="Campaign Banner" />
              ) : (
                <img src={`${CDN_PRODUCT_CAMPAIGN}${bannerImage}`} alt="Campaign Banner" />
              )}
            </>
          )}
        </div>
        <div className="header-text">
          <h4 style={{ fontWeight: "bold" }}>
            {localStorage.getItem("storeid") === "2" ? thaiTitle : filterTitle}
          </h4>
          <span className="compaignspan-text">{localStorage.getItem("storeid") === "2" ? filterdetailsthai : filterDetails}</span>
          <div class="search_box_wrapper">
            <input
              class="search_input"
              placeholder={`${t("SEARCHPLACEHOLDER")}`}
              name="srch-term"
              id="srch-term"
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button class="search_btn">
              <i className="fa fa-search"></i>
            </button>
          </div>
          {windowWidth <= 912 && (
            <aside className="main-menu">
              <CampaignSidebar
                products={campaignProducts}
                Id={Id}
                currentPage={currentpage}
                setCurrentPage={setCurrentPage} // Must pass this too 
                categoryId={categoryId}
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                mobileCategory={mobileCategory}
                setMobileCategory={setMobileCategory}
                type="mobile"
              />
            </aside>
          )}
        </div>

        <div className="main-and-products">

          {windowWidth > 912 && (
            <aside className="main-menu">
              <CampaignSidebar
                products={campaignProducts}
                Id={Id}
                currentPage={currentpage} //  Correct prop
                setCurrentPage={setCurrentPage} // Must pass this too 
                categoryId={categoryId}
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                mobileCategory={mobileCategory}
                setMobileCategory={setMobileCategory}
                type="web"
              />
            </aside>
          )}

          <div className="campaign-products-container">
            <div className="PRODUCTPLP__DATA my_product_section">
              <div className="PRODUCTPLP__CONTENT">
                <div className="PRODUCTPLP__DATA">
                  {!loader && filteredProducts.length === 0 && (
                    <p className="no_product">{"NOPRODUCTAVAILABLE"}</p>
                  )}
                  <InfiniteScroll
                    dataLength={filteredProducts?.length}
                    next={loadNextPage} // Call loadNextPage to increment currentPage
                    hasMore={Math.ceil(campaignProductsCount / 20) == currentpage ? false : true}
                    loader={loader && [...Array(20)].map((_, index) =>
                      <NewCardSkeleton
                        devicetype={window.innerWidth > 912 ? "desktop" : "mobile"}
                        key={index} />)}
                    scrollThreshold={0.5}
                  >
                    {filteredProducts.map((product, index) => (
                      <ProductCard
                        key={index}
                        data={product}
                        setRefreshAPI={setRefreshAPI}
                        refreshAPI={refreshAPI}
                        devicetype={
                          windowWidth > 912 ? "desktop" : "mobile"
                        }
                      />
                    ))}
                  </InfiniteScroll>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CampaignProduct;